// src/actions/imageActions.js

export const setSelectedImage = (imageMetaData) => ({
  type: "SET_SELECTED_IMAGE",
  payload: imageMetaData,
});
